import createAxios from './api'

const PATH = 'alfaRefs'

export default {
  async initiateCreateAlfaRef(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/initiateCreate`, req)
    return resp.data
  },

  async completeCreateAlfaRef(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/completeCreate`, req)
    return resp.data
  },

  async getAlfaRef(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)
    return resp.data
  },

  async listAlfaRefs(userId, q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        userId, q, pageRequest
      }
    })
    return resp.data
  },

  async updateAlfaRef(id, dto) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, dto)
  },

  async deleteAlfaRef(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  }
}
